import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/facebook-marketplace-shipping';

export default function Example() {
  return (
    <>
      <Head>
        <title>Understand How Facebook Marketplace Shipping Works</title>
        <meta
          name='description'
          content='Familiarize yourself with the ins and out of shipping on the Facebook marketplace and learn some best-kept tips to guide you along the way.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/facebook-marketplace-shipping' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/facebook-marketplace-shipping' />
        <meta property='og:title' content='Understand How Facebook Marketplace Shipping Works' />
        <meta
          property='og:description'
          content='Familiarize yourself with the ins and out of shipping on the Facebook marketplace and learn some best-kept tips to guide you along the way.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
